module.exports = __webpack_public_path__ + "img/clio.25eb2fee.webp";